/* unplugin-vue-components disabled */import { render } from "./item-proofreading.vue?vue&type=template&id=98440d48"
import script from "./item-proofreading.vue?vue&type=script&lang=js"
export * from "./item-proofreading.vue?vue&type=script&lang=js"

import "./item-proofreading.vue?vue&type=style&index=0&id=98440d48&lang=less&scope=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__